// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"00541aba","127":"27024fd3","204":"7e2f2c20","217":"27024fd3","426":"27024fd3","521":"27024fd3","664":"27024fd3","859":"27024fd3","885":"27024fd3","973":"27024fd3"}[chunkId] + ".chunk.css";
};